import { useEffect } from 'react';
import toast from 'react-hot-toast';
import type { ConvertToRestDayOutcome } from '../useConvertToRestDay';

export const ConvertToRestDayToast = ({
  outcome,
  onShown,
}: {
  outcome: ConvertToRestDayOutcome;
  onShown: () => void;
}) => {
  const { workoutId, title, success } = outcome;
  useEffect(() => {
    const id = `convert-to-rest-day-${workoutId}`;
    if (success) toast.success(`“${title}” is now a Rest Day`, { id });
    else
      toast.error(`“${title}” could not be converted. Please try again.`, {
        id,
      });
    onShown();
  }, [workoutId, title, success, onShown]);
  return null;
};
